import { createLogger } from "@/lib/observability/logger";
import loadPlacesLibrary from "../common/load-places-library";

// getVenuePredictions gets venue predictions from the Google Maps API
export default async function getVenuePredictions(
  query: string,
): Promise<google.maps.places.PlacePrediction[]> {
  const logger = createLogger("getVenuePredictions");
  if (!query) return [];

  try {
    const { AutocompleteSuggestion } = await loadPlacesLibrary();

    const autocompleteResponse =
      await AutocompleteSuggestion.fetchAutocompleteSuggestions({
        input: query,
        // Include all location types for venues
      });

    return autocompleteResponse.suggestions
      .map((suggestion) => suggestion.placePrediction)
      .filter(
        (prediction): prediction is google.maps.places.PlacePrediction =>
          prediction !== null,
      );
  } catch (error) {
    logger.logError("getVenuePredictions", error as Error);
    throw new Error("Unable to search venues. Please try again.");
  }
}
